import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 7.888888888888488 5.461538461538112",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 7.888888888888488 5.461538461538112\" fill=\"none\" id=\"icon-arrow-down\"><path id=\"icon-arrow-down_三角形 1\" fill-rule=\"evenodd\" style=\"fill:#2E88FF\" transform=\"translate(0 0)  rotate(-180 3.9444444444442444 2.7307692307690927)\" opacity=\"1\" d=\"M0.53,4.1L7.36,4.1L3.94,0L0.53,4.1Z \" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol